module.exports = __webpack_public_path__ + "img/Menu-10.49afd53d.png";